<template><div><h1 id="bestellarten" tabindex="-1"><a class="header-anchor" href="#bestellarten"><span>Bestellarten</span></a></h1>
<p>Bestellart — Wie per Telefon, Fax etc.</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Im Auftrag wird festgehalten, auf welchem Weg der Kunde eine Bestellung aufgegeben hat, was für Auswertungen genutzt werden kann. Die Tabelle dient als Grundlage für die Auftragserfassung.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Bestellarten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>BestArt</dt>
<dd>Kürzel für Bestellart, 4-stellig, alphanumerisch</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Bestellart</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


